exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.must .el-form-item__label:before {\r\n    content: '*';\r\n    color: #f56c6c;\r\n    margin-right: 4px;\n}\r\n", ""]);

// exports
